var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "user (5)",
    fill: "#0D1116",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.082,
    height: 13.497,
    viewBox: "0 0 12.082 13.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8898"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8897"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10875",
    d: "M6.046 0a3.5 3.5 0 103.5 3.5 3.514 3.514 0 00-3.5-3.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8900"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8899"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10876",
    d: "M12.055 9.808a3.266 3.266 0 00-.352-.643 4.356 4.356 0 00-3.015-1.9.645.645 0 00-.444.107 3.736 3.736 0 01-4.407 0 .574.574 0 00-.444-.107 4.324 4.324 0 00-3.015 1.9 3.765 3.765 0 00-.352.643.325.325 0 00.015.291 6.1 6.1 0 00.413.612 5.818 5.818 0 00.7.8 9.186 9.186 0 00.7.612 6.979 6.979 0 008.325 0 6.729 6.729 0 00.7-.612 7.066 7.066 0 00.7-.8 5.362 5.362 0 00.413-.612.261.261 0 00.063-.291z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyContact);
export default __webpack_public_path__ + "static/media/reply-contact.1766caad95886eb9cc5476115238f43a.svg";
export { ForwardRef as ReactComponent };